var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfectMix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#CC0000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24,
    r: 13
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 24,
    r: 13
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 42,
    r: 13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectMix);
export default __webpack_public_path__ + "static/media/perfect-mix.66085b6f06464a955060d32a2aba37d3.svg";
export { ForwardRef as ReactComponent };